import { render, staticRenderFns } from "./BibliometricInfo.vue?vue&type=template&id=358fd72f"
import script from "./BibliometricInfo.vue?vue&type=script&lang=js"
export * from "./BibliometricInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports